import type { Row } from './types';

const mockData: Row[] = [
    {
        childIds: [2, 3],
        id: 1,
        lastActivity: 'Updated Phone Number',
        lastEdited: '6/6/2025 @10:55 AM',
        name: 'Tom Spencer',
        parentId: 0
    },
    {
        childIds: [],
        id: 2,
        lastActivity: 'Updated Address',
        lastEdited: '6/6/2025 @11:05 AM',
        name: `Adam's Family Farm`,
        parentId: 1
    },
    {
        childIds: [5, 6],
        id: 3,
        lastActivity: 'Updated Address',
        lastEdited: '6/6/2025 @11:15 AM',
        name: 'Spencer Family Farm',
        parentId: 1
    },
    {
        childIds: [],
        id: 4,
        lastActivity: 'Updated Phone Number',
        lastEdited: '6/6/2025 @10:55 AM',
        name: 'Ryan Johnson',
        parentId: 0
    },
    {
        childIds: [],
        id: 5,
        lastActivity: 'Updated Boundary',
        lastEdited: '6/6/2025 @11:25 AM',
        name: 'Corn Field',
        parentId: 3
    },
    {
        childIds: [7],
        id: 6,
        lastActivity: 'Updated Boundary',
        lastEdited: '6/6/2025 @11:35 AM',
        name: 'Soy Field',
        parentId: 3
    },
    {
        childIds: [],
        id: 7,
        lastActivity: 'Updated Chemical Rate',
        lastEdited: '6/6/2025 @11:45 AM',
        name: 'Fertilizer Application',
        parentId: 6
    },
    {
        childIds: [],
        id: 8,
        lastActivity: 'Updated Phone Number',
        lastEdited: '6/6/2025 @10:55 AM',
        name: 'Jane Doe',
        parentId: 0
    },
    {
        childIds: [],
        id: 9,
        lastActivity: 'Updated Phone Number',
        lastEdited: '6/6/2025 @10:55 AM',
        name: 'Joe Shmoe',
        parentId: 0
    },
    {
        childIds: [],
        id: 10,
        lastActivity: 'Updated Address',
        lastEdited: '6/6/2025 @11:15 AM',
        name: 'Vanderbilt Family Farm',
        parentId: 1
    }
];

export { mockData };
